<template>
	<div id="qvo-app">
		<titlebar/>
		<notificationCenter/>
		<navbar/>
		<main id="content" class="support">
			<h1>Support</h1>
			<p>Need help?</p>
			<p>Call Us at <a href="tel:555-555-5555">555-555-5555</a></p>
		</main>
		<footnote/>
	</div>
</template>

<script>
	//import { mapActions /*, mapState, mapGetters*/ } from 'vuex';

	export default {
		name: 'support',
	}
</script>

<!-- Page-Specific Style Import (don't edit here) -->
<style lang="scss">
</style>

